import type { GlobalQualification, LocalQualification } from '@/libs/interfaces'

import { MOCK_ORG_ID, MOCK_STORE_ID_1, MOCK_STORE_ID_2 } from './seed'

/** A few global (org-wide) and local (per-store) qualifications. */

export const mockGlobalQualifications: GlobalQualification[] = [
  {
    globalQualID: 'global-qual-1',
    globalQualName: 'Volvo Certified',
    orgID: MOCK_ORG_ID,
  },
  {
    globalQualID: 'global-qual-2',
    globalQualName: 'EV Specialist',
    orgID: MOCK_ORG_ID,
  },
]

export const mockLocalQualifications: LocalQualification[] = [
  {
    localQualID: 'local-qual-1',
    localQualName: 'Tire Fitting',
    storeID: MOCK_STORE_ID_1,
  },
  {
    localQualID: 'local-qual-2',
    localQualName: 'Paint Booth Operator',
    storeID: MOCK_STORE_ID_2,
  },
]
